import { Element_Base, Element_Point_StyleMetadata_ModelUtil, Element_LineString_StyleMetadata_ModelUtil, Element_Polygon_StyleMetadata_ModelUtil, ElementType } from '~/common/typescript/models/Element';
import MapUtils from '~/components/Map/utils/MapUtils';
import { FeatureCollection } from '@turf/turf';

export const ElementItemUtil = {
  zoomToElement: (element: Element_Base) => {
    MapUtils.zoomToFeatureCollection(JSON.parse(element.geom));
  },
  highlightElement: (element: Element_Base) => {
    const point = JSON.parse(element.geom);
    const featureCollection = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          properties: {
            name: element.name,
          },
          geometry: point,
        },
      ],
    } as FeatureCollection;

    // Extract style information for highlight
    let elementStyle: { size?: number; frame?: string; strokeWidth?: number; opacity?: number } = {};
    if (element.metadata) {
      try {
        const metadata = JSON.parse(element.metadata);
        if (metadata.style) {
          if (element.type === ElementType.POINT) {
            const style = Element_Point_StyleMetadata_ModelUtil.normalize(metadata.style);
            elementStyle = {
              size: style.size,
              frame: style.frame,
            };
          } else if (element.type === ElementType.LINESTRING) {
            const style = Element_LineString_StyleMetadata_ModelUtil.normalize(metadata.style);
            elementStyle = {
              strokeWidth: style.strokeWidth,
              opacity: style.opacity,
            };
          } else if (element.type === ElementType.POLYGON) {
            const style = Element_Polygon_StyleMetadata_ModelUtil.normalize(metadata.style);
            elementStyle = {
              strokeWidth: style.strokeWidth,
              opacity: style.opacity,
            };
          }
        }
      } catch (error) {
        console.error('Error parsing element metadata for highlight:', error);
      }
    }

    MapUtils.highlightFeatureCollection(featureCollection, elementStyle);
  },
};
